import { client } from '../client';

declare const CategoryIdType: unique symbol;
export type CategoryId = number & {
  readonly type: typeof CategoryIdType;
};
export interface Category {
  id: CategoryId;
  name: string;
  deleted: boolean;
}

interface ApiCategory {
  categoryId: number;
  categoryName: string;
  deleted: boolean;
}

const asApiCategory = ({ id, name, deleted }: Category): ApiCategory => ({
  categoryId: id,
  categoryName: name,
  deleted,
});

const asCategory = ({
  categoryName,
  categoryId,
  deleted,
}: ApiCategory): Category => ({
  id: categoryId as unknown as CategoryId,
  name: categoryName,
  deleted,
});

const url = (id?: number) =>
  `/timesheets/categories${id == null ? '' : `/${id}`}`;

const get = (): Promise<Category[]> =>
  client.get<ApiCategory[]>(url()).then((x) => x.map(asCategory));
const remove = (id: CategoryId): Promise<void> => client.delete(url(id));

type CreateCategoryRequest = Pick<ApiCategory, 'categoryName'>;
const create = (categoryName: string, requestId: string): Promise<Category> =>
  client
    .post<ApiCategory, CreateCategoryRequest>(
      url(),
      { categoryName },
      { headers: { 'X-Request-Id': requestId } },
    )
    .then(asCategory);
const update = (category: Category): Promise<Category> =>
  client
    .put<ApiCategory, ApiCategory>(url(category.id), asApiCategory(category))
    .then(asCategory);

export const CategoriesApi = {
  get,
  remove,
  create,
  update,
};
